<template>
    <div
        v-if="rows.length"
        class="card mb-4 series-outline d-print-none"
    >
        <h5 class="card-header">
            {{ $t('seriesOutline') }}
        </h5>

        <div class="card-body">
            <div v-if="! rows">
                {{ $t('loading') }}...
            </div>

            <series-outline-lesson
                v-for="lesson in rows"
                :key="lesson.id"
                :lesson="lesson"
            />
        </div>
    </div>
</template>

<script>
import axios from 'axios';
import SeriesOutlineLesson from './SeriesOutlineLesson';

export default {
    components: {
        SeriesOutlineLesson,
    },

    props: {
        seriesId: {
            type: Number,
            required: true,
        },
        languageId: {
            type: [Number, String],
            required: false,
            default: null,
        },
        lessonId: {
            type: Number,
            required: false,
            default: null,
        },
    },

    data() {
        return {
            isLoading: null,
            rows: [],
        };
    },

    watch: {
        languageId: function () {
            this.getRows();
        },
    },

    mounted: function () {
        this.getRows();
    },

    methods: {
        getRows: function () {
            this.isLoading = true;
            this.rows = [];

            axios({
                method: 'get',
                url: `/subscriber/api/series/${this.seriesId}/lessons/`,
                params: {
                    language_id: this.languageId,
                    components: true,
                },
            })
            .then((response) => {
                this.rows = response.data;
                this.isLoading = false;
            });
        },
    },
};
</script>

<style>
    .card.series-outline p
    {
        margin-bottom: 0 !important;
    }
</style>
